import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const DS = {
  colors: {
    bg: "#F9FAFB",
    primary: "#012442",
    accent: "#FF3100",
    subtleBorder: "rgba(1, 36, 66, 0.10)",
    subtleFill: "rgba(1, 36, 66, 0.04)",
  },
  shadow: "0px 3px 3px rgba(0,14,51,0.25), 0px 1px 2px rgba(0,14,51,0.25)",
  fontWeight: 400,
};

function CircularProgressWithLabel(props) {
  const value = Number.isFinite(props.value) ? props.value : 0;

  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: DS.colors.bg,
        borderRadius: "999px",
        boxShadow: DS.shadow,
        p: 1,
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 8,
          borderRadius: "999px",
          background: `radial-gradient(circle at 30% 30%, ${DS.colors.subtleFill}, transparent 60%)`,
          pointerEvents: "none",
        },
        "&::after": {
          content: '""',
          position: "absolute",
          inset: 0,
          borderRadius: "999px",
          border: `1px solid ${DS.colors.subtleBorder}`,
          pointerEvents: "none",
        },
      }}
    >
      <CircularProgress
        variant="determinate"
        size={96}
        thickness={4.5}
        sx={{
          color: DS.colors.accent,
          "& .MuiCircularProgress-circle": {
            strokeLinecap: "round",
            transition: "stroke-dashoffset 100ms linear",
          },
          "& .MuiCircularProgress-circleTrack": {
            stroke: "rgba(1, 36, 66, 0.12)",
          },
          "@media (prefers-reduced-motion: reduce)": {
            "& .MuiCircularProgress-circle": {
              transition: "none",
            },
          },
        }}
        {...props}
        value={value}
      />

      <Box
        sx={{
          inset: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.25,
          userSelect: "none",
        }}
      >
        <Typography
          variant="h5"
          component="div"
          sx={{
            color: DS.colors.primary,
            fontWeight: DS.fontWeight,
            letterSpacing: "0.01em",
            textShadow: "0 1px 0 rgba(249,250,251,0.8)",
          }}
          aria-label={`Progresso: ${Math.round(value)} por cento`}
        >
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

export default function CircularWithValueLabel({ value }) {
  const [progress, setProgress] = React.useState(0);
  const hasControlledValue = Number.isFinite(value);

  React.useEffect(() => {
    if (hasControlledValue) {
      setProgress(Math.max(0, Math.min(100, Math.round(value))));
      return;
    }

    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 0 : prevProgress + 1
      );
    }, 40);

    return () => {
      clearInterval(timer);
    };
  }, [hasControlledValue, value]);

  return <CircularProgressWithLabel value={progress} />;
}
